import BackAssessmentManagerMainList from "../manager";

export default function BackAssessmentHistoryList() {
  return (
    <>
      <BackAssessmentManagerMainList moduleType="history" />
    </>
  );
}
